import { addWeeks, format } from 'date-fns';

/**
 * Format an x-axis tick label for the analytics activity charts.
 *
 * recharts can invoke the tick formatter with empty/invalid values (for example
 * the placeholder ticks rendered before chart data has loaded). A date-fns
 * `format()` call on an Invalid Date throws, which previously bubbled up and
 * crashed the whole Analytics page render, so guard invalid dates and return an
 * empty label instead of throwing.
 *
 * @param date  Raw tick value (expected to be an ISO date string).
 * @param index Zero-based tick index; surfaced 1-based in week/month/year labels.
 * @param period Selected timeframe granularity ('day' | 'week' | 'month' | 'year').
 */
export const formatChartXAxisLabel = (date: string, index: number, period?: string): string => {
  const dateObj = new Date(date);

  if (isNaN(dateObj.getTime())) {
    return '';
  }

  switch (period) {
    case 'day':
      return format(dateObj, 'EEE, MMM do');
    case 'week':
      return `WEEK ${index + 1}\n${format(dateObj, 'do')} - ${format(
        addWeeks(dateObj, 1),
        'do, MMM'
      )}`;
    case 'month':
      return `MONTH ${index + 1}\n${format(dateObj, 'MMMM yyyy')}`;
    case 'year':
      return `YEAR ${index + 1}\n${format(dateObj, 'yyyy')}`;
    default:
      return date;
  }
};
